import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import FocusContent from '@perpay-web/components/composite/FocusLayout/FocusContent';
import FocusFooter from '@perpay-web/components/composite/FocusLayout/FocusFooter';
import FocusLayout from '@perpay-web/components/composite/FocusLayout/FocusLayout';
import PasswordForm from '@perpay-web/components/composite/PasswordForm/PasswordForm';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import { useMount } from '@perpay-web/hooks/useMount';
import { useScrollReset } from '@perpay-web/hooks/useScrollReset';
import { noop } from '@perpay-web/utils/noop';
import { formatCurrency } from '@perpay-web/utils/stringUtils';

import styles from './CardApplicationDirectDepositSuccess.scss';

const CardApplicationDirectDepositSuccess = ({
    onMount,
    amount,
    isLoading,
    onSubmitPassword,
    onSubmitPasswordErrors,
    onClickBackToDashboard = noop,
    needsPassword = true,
}) => {
    useScrollReset();
    useMount(() => onMount());

    if (isLoading) {
        return <WarningLoaderCircle />;
    }

    return (
        <FocusLayout className={styles['focus-layout']}>
            <FocusContent className={styles['focus-content']}>
                <div className={styles.title}>Your direct deposit is set!</div>
                <Stack className={styles.stack}>
                    <div className={styles.stack__item}>
                        <div className={styles['stack__item__icon--card']} />
                        <div className={styles.stack__item__text}>
                            We&apos;ll receive your automatic direct deposit of{' '}
                            {formatCurrency(amount)} on your next payday.
                        </div>
                    </div>
                    <div className={styles.stack__item}>
                        <div className={styles['stack__item__icon--truck']} />
                        <div className={styles.stack__item__text}>
                            As soon as your direct deposit is received,
                            we&apos;ll ship your card!
                        </div>
                    </div>
                </Stack>
            </FocusContent>

            {needsPassword ? (
                <div className={styles.password__form}>
                    <div className={styles['password__form-subtitle']}>
                        Next steps:
                    </div>
                    <div className={styles['password__form-title']}>
                        Set your password
                    </div>
                    <PasswordForm
                        onSubmit={onSubmitPassword}
                        errors={onSubmitPasswordErrors}
                        contentClassName={styles['password__form-content']}
                        buttonText='Done'
                    />
                </div>
            ) : (
                <FocusFooter>
                    <CardCta
                        Component={CustomButton}
                        type='submit'
                        onClick={onClickBackToDashboard}
                    >
                        Continue to dashboard
                    </CardCta>
                </FocusFooter>
            )}
        </FocusLayout>
    );
};

export default CardApplicationDirectDepositSuccess;
